/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import { FormattedMessage } from 'react-intl';

import 'react-datetime/css/react-datetime.css';
import moment from 'utils/moment';
import icon from '../../../icons/clock.svg';
import styles from './datetime.module.scss';
import '../../component.scss';
import {
  renderInfoForType,
  getFieldUsesSeconds,
  getTimeFormat,
  getDateTimeFormat
} from '../../../utils/helpers';

class Date extends Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false,
      currentDate: moment(moment().format())
    };
    this.focused = false;
    const { isRequired, updateFieldErrors, answer, noDefault, settings, handleFieldErrorChanged, fieldId } = this.props;
    if (settings?.validations && settings?.validations?.condition?.key && answer !== '') {
      const validDate = this.handleDisableFutureDates(moment(answer));
      if (!validDate) {
        handleFieldErrorChanged(fieldId, true);
      }
    }
    if (noDefault && isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  componentDidUpdate() {
    const { init, currentDate }= this.state;
    const { answer, noDefault } = this.props;
    if (!answer && currentDate && !init && !noDefault) {
      this.sendCurrentDate();
    }
  }

  durationCalculation = async (
    startDate1, endDate1, calculationFormat, timeDiff, format, field, multiFieldId, multiField, handleValueChange, handleFieldErrorChanged
  ) => {
    let startDate = startDate1;
    let endDate = endDate1;
    if (startDate && endDate && moment(startDate).isValid() && moment(endDate).isValid()) {
      let timeDifference = '';
      if (calculationFormat === 'days') {
        startDate = moment(startDate).startOf('day');
        endDate = moment(endDate).startOf('day');
      }
      if (moment(endDate).isAfter(moment(startDate)) || timeDiff > 0 || field?.settings?.negative_duration_cal) {
        const diff = (moment(endDate).set({ second: 0, millisecond: 0 })).diff(moment(startDate).set({ second: 0, millisecond: 0 }));
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const seconds = Math.floor((diff / 1000) % 60);
        const minutes = ((diff / 1000 / 60) % 60);
        const hours = (((diff / 1000 / 60 / 60) % 24));
        if (format?.key === 'days') {
          if (field?.duration_fields?.excludedDays?.length > 0) {
            const excludedDays = field?.duration_fields?.excludedDays;
            let iterationDay = moment(startDate).format('YYYY-MM-DD HH:MM');
            let consideredDays = 0;
            for (let i = 0; days && endDate >= moment(iterationDay); i++) {
              let weekDays = moment(iterationDay).format('dd').toUpperCase();
              const validateDay = excludedDays.some(e => e.id === weekDays);
              if (!validateDay) {
                consideredDays += 1;
              }
              iterationDay = moment(startDate).add(i+1, 'days').format('YYYY-MM-DD HH:MM');
            }
            timeDifference = consideredDays;
          } else if (multiField?.durationFieldsMultiField?.excludedDays?.length > 0) {
            const excludedDays = multiField?.durationFieldsMultiField?.excludedDays;
            let iterationDay = moment(startDate).format('YYYY-MM-DD HH:MM');
            let consideredDays = 0;
            for (let i = 0; days && endDate >= moment(iterationDay); i++) {
              let weekDays = moment(iterationDay).format('dd').toUpperCase();
              const validateDay = excludedDays.some(e => e.id === weekDays);
              if (!validateDay) {
                consideredDays += 1;
              }
              iterationDay = moment(startDate).add(i+1, 'days').format('YYYY-MM-DD HH:MM');
            }
            timeDifference = consideredDays;
          } else {
            timeDifference = days;
          }
        } else if (format?.key === 'days_hours') {
          const totalMsInDay = 1000 * 60 * 60 * 24;
          const totalDays = diff / totalMsInDay;
          const floorDays = Math.floor(totalDays);
          const totalHours = diff / (1000 * 60 * 60);
          const remainingHours = Math.floor(totalHours - floorDays * 24);
          timeDifference = `${floorDays} days ${remainingHours} hour`;
        } else if (format?.key === 'hours') {
          timeDifference = this.convertTime((days * 24) + hours);
        } else if (format?.key === 'minutes') {
          timeDifference = this.convertTime((days * 1440) + (Math.floor(hours) === 0 ? Math.floor(hours) + minutes : hours * 60));
        } else if (format?.key === 'seconds') {
          timeDifference = Math.floor((days * 86400) + (Math.floor(hours) * 3600) + (Math.floor(minutes) * 60) + seconds);
        }
        if (field.settings?.isOneDayDuration && field.settings.isOneDayDuration === 1) {
          if (field?.settings?.negative_duration_cal && timeDifference !== 0) {
            timeDifference = Number((parseFloat(timeDifference) - 1).toFixed(2));
          } else {
            timeDifference = Number((parseFloat(timeDifference) + 1).toFixed(2));
          }
        }
      }
      if (timeDifference !== undefined && timeDifference?.toString() !== 'NaN') {
        if (multiFieldId && startDate && endDate) {
          await handleValueChange(timeDifference, multiFieldId, multiFieldId ? 'multi_field': '', {
            multiFieldId: multiFieldId || null,
            multiFieldType: multiField?.type?.key || null
          });
        } else if (!multiFieldId) {
          await handleValueChange(timeDifference, field?.id);
        }
      }
      if ((startDate > endDate && !field?.settings?.negative_duration_cal) || timeDifference?.toString() === 'NaN'
        || (field?.required && (timeDifference === undefined || timeDifference === null || timeDifference === ''))) {
          handleFieldErrorChanged(field?.id, true);
      } else {
        handleFieldErrorChanged(field?.id, false);
      }
    }
  }

  convertTime = (value) => {
    let hours = Math.floor(value);
    let minutes = String(Math.floor((value - hours) * 60)).padStart(2, '0');
    return parseFloat(`${hours}.${minutes}`);
  }

  sendCurrentDate = () => {
    const { fieldId, isRequired, handleValueChange, handleFieldErrorChanged, updateFieldErrors, dateEditable } = this.props;
    const { currentDate } = this.state;
    this.setState({ init: true });
    if (dateEditable) {
      handleValueChange(currentDate, fieldId);
    } else {
      handleValueChange(currentDate.format(), fieldId);
    }
    let updatedErrors = [];
    if (!currentDate) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  validateDate = (inputValue) => {
    const { sendWithSecond, settings } = this.props;
    const useSeconds = getFieldUsesSeconds({ sendWithSecond, settings }, sendWithSecond);
    const formatString = getDateTimeFormat(useSeconds);
    const value = moment(inputValue);
    if (!value?.isValid()) {
      return true;
    }
    const currentValue = value.format(formatString);

    return !moment(currentValue, formatString, true).isValid();
  }

  validateTimeFormat = (input) => {
    const regex = /^(0?[1-9]|1[0-2]):([0-5][0-9])\s?(AM|PM)$/i;
    return regex.test(input);
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange,
      handleFieldErrorChanged,
      isRequired,
      updateFieldErrors,
      answer,
      dateEditable,
      onlyTime,
      answers,
      durationAnswers,
      allFields,
      sendWithSecond: sendWithSecondProp,
      settings
    } = this.props;
    const sendWithSecond = getFieldUsesSeconds({ sendWithSecond: sendWithSecondProp, settings }, sendWithSecondProp);
    let newValue = value;
    const timeFormat = getTimeFormat(sendWithSecond);
    const usesMeridiem = timeFormat?.toLowerCase?.().includes('a');
    if (value !== '' && dateEditable) {
      if (!onlyTime && (typeof value) === 'string' && value?.length > answer?.length) {
        if (value?.match(/^([0-9][0-9])$/)) {
          handleValueChange(`${value}/`, fieldId);
          this.setState({ renderAnswer: true });
        } else if (value?.match(/^([0-9][0-9]\/[0-9][0-9])$/)) {
          handleValueChange(`${value}/`, fieldId);
          this.setState({ renderAnswer: true });
        } else if (value?.match(/^([0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9])$/)) {
          handleValueChange(`${value} `, fieldId);
          this.setState({ renderAnswer: true });
        } else if (value?.match(/^([0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9] [0-9][0-9])$/)) {
          handleValueChange(`${value}:`, fieldId);
          this.setState({ renderAnswer: true });
        } else if (value?.match(/^([0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9] [0-9][0-9]:[0-9][0-9])$/)) {
          if (sendWithSecond) {
            newValue = `${value}:`;
          } else if (usesMeridiem) {
            newValue = `${value} AM`;
          } else {
            newValue = value;
          }
          handleValueChange(newValue, fieldId);
          this.setState({ renderAnswer: true });
        } else if (sendWithSecond && value?.match(/^([0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9] [0-9][0-9]:[0-9][0-9]:[0-9][0-9])$/)) {
          handleValueChange(value, fieldId);
          this.setState({ renderAnswer: true });
        } else {
          handleValueChange(value, fieldId);
          this.setState({ renderAnswer: false });
        }
      } else if (onlyTime && (typeof value) === 'string' && value?.length > answer?.length) {
        if (value?.match(/^([0-9][0-9])$/)) {
          handleValueChange(`${value}:`, fieldId);
          this.setState({ renderAnswer: true });
        } else if (value?.match(/^([0-9][0-9]:[0-9][0-9])$/)) {
          if (sendWithSecond) {
            handleValueChange(`${value}:`, fieldId);
          } else if (usesMeridiem) {
            handleValueChange(`${value} AM`, fieldId);
          } else {
            handleValueChange(value, fieldId);
          }
          this.setState({ renderAnswer: true });
        } else if (sendWithSecond && value?.match(/^([0-9][0-9]:[0-9][0-9]:[0-9][0-9])$/)) {
          handleValueChange(value, fieldId);
          this.setState({ renderAnswer: true });
        } else {
          handleValueChange(value, fieldId);
          this.setState({ renderAnswer: false });
        }
      } else {
        handleValueChange(value, fieldId);
        this.setState({ renderAnswer: false });
      }
    } else if (value !== '') {
      handleValueChange(value?.format(), fieldId);
      if (allFields && allFields.length > 0) {
        setTimeout(() => {
          let fields = [...allFields];
          let fieldAnswers = { ...durationAnswers };
          const durationFields = fields?.filter(
            (e) => {
              if (e.type === 'duration') {
                return fields.some(
                    f => (f.id === e.duration_fields?.startDateField?.fieldId || f.id === e.duration_fields?.endDateField?.fieldId)
                    && (f.type === 'datetime' || f.type === 'time')
                );
              }
              if (e.type === 'multi_field' && e.multiple_fields) {
                return Object.values(e.multiple_fields).some(
                  multiField => multiField?.type?.key === 'duration'
                  && (multiField?.durationFieldsMultiField?.startDateField?.fieldId
                    || multiField?.durationFieldsMultiField?.endDateField?.fieldId)
                );
              }
              return false;
            }
          );
          if (durationFields) {
            durationFields.forEach(async (field) => {
              if (field.type !== 'duration') {
                let startFieldId;
                let endFieldId;
                let calculationFormat;
                let format;
                let startDate;
                let endDate;
                if (field.type === 'multi_field' && field.multiple_fields) {
                  const foundDurationMultiFields = Object.entries(field.multiple_fields).reduce((acc, [key, multiF]) => {
                    if (multiF?.type?.key === 'duration') {
                      acc[key] = multiF;
                    }
                    return acc;
                  }, {});
                  if ((Object.keys(foundDurationMultiFields))?.length > 0) {
                    Object.entries(foundDurationMultiFields).forEach(([key, multiF]) => {
                    startFieldId = multiF.durationFieldsMultiField?.startDateField?.fieldId;
                    endFieldId = multiF.durationFieldsMultiField?.endDateField?.fieldId;
                    calculationFormat = multiF.durationFieldsMultiField?.calculationFormat?.key;
                    format = multiF.durationFieldsMultiField?.calculationFormat;
                    startDate = fieldId === startFieldId ? moment(value) : fieldAnswers?.[startFieldId] && moment(fieldAnswers?.[startFieldId]);
                    endDate = fieldId === endFieldId ? moment(value) : fieldAnswers?.[endFieldId] && moment(fieldAnswers?.[endFieldId]);
                    const timeDiff = moment(endDate).diff(moment(startDate), 'minutes');
                  if (moment(startDate).isValid() && moment(endDate).isValid()) {
                    this.durationCalculation(
                      startDate,
                      endDate,
                      calculationFormat,
                      timeDiff,
                      format,
                      field,
                      key,
                      multiF,
                      handleValueChange,
                      handleFieldErrorChanged
                    );
                  }
                  });
                  }
                }
              }
            });
          }
        }, 0);
      }
    } else {
      handleValueChange('', fieldId);
    }
    const durationFields = allFields?.filter(
      e => e.type === 'duration' && allFields.some(
        f => (f.id === e.duration_fields?.startDateField?.fieldId || f.id === e.duration_fields?.endDateField?.fieldId)
        && (f.type === 'datetime' || f.type === 'time')
      )
    );
    if (durationFields?.length > 0) {
      durationFields.forEach(async (field) => {
        let startFieldId;
        let endFieldId;
        let calculationFormat;
        let format;
        let multiFieldId;
        let multiField;
        let startDate;
        let endDate;
        startFieldId = field?.duration_fields?.startDateField?.fieldId;
        endFieldId = field?.duration_fields?.endDateField?.fieldId;
        calculationFormat = field?.duration_fields?.calculationFormat?.key;
        startDate = fieldId === startFieldId ? moment(value) : answers?.[startFieldId] && moment(answers?.[startFieldId]);
        endDate = fieldId === endFieldId ? moment(value) : answers?.[endFieldId] && moment(answers?.[endFieldId]);
        const timeDiff = moment(endDate).diff(moment(startDate), 'minutes');
        format = field?.duration_fields?.calculationFormat;
        if (startDate && endDate && moment(startDate).isValid() && moment(endDate).isValid()) {
          this.durationCalculation(
            startDate,
            endDate,
            calculationFormat,
            timeDiff,
            format,
            field,
            multiFieldId,
            multiField,
            handleValueChange,
            handleFieldErrorChanged
          );
        }
      });
    }
    let updatedErrors = [];

    if (!value) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
      const validDate = this.handleDisableFutureDates(moment(value));
      if (!validDate) {
        handleFieldErrorChanged(fieldId, true);
      }
    }
    if (dateEditable && value && this.validateDate(newValue)) {
      handleFieldErrorChanged(fieldId, true);
    }
    updateFieldErrors(updatedErrors);
  }

  handleDisableFutureDates = (rawDate) => {
    const { answer = moment(moment(rawDate).format('YYYY-MM-DD HH:mm')) } = this.props;
    // milliseconds are removed everywhere this will compare only MM-DD-YYYY HH:MM only.
    const selectedDate = moment(answer).startOf('minute').millisecond(0);
    const { settings, onlyTime, answers } = this.props;
    const validations = settings?.validations || {};
    let today = moment().startOf('day').millisecond(0);
    let valid = true;
    const customValidationDate = answers ? answers[validations?.condtional_custom_field?.fieldId] : false;
    if (customValidationDate) {
    today = moment(customValidationDate).startOf('day').millisecond(0);
    }
    if (validations?.condition?.key === 'less_than' || (validations?.condition?.key === 'less_than_custom_date' && customValidationDate)) {
          if (validations?.condition?.key === 'less_than') {
            today = moment().startOf('minute').millisecond(0);
          }
      valid = selectedDate.isSameOrBefore(today);
      if (valid && onlyTime && validations?.conditional_hours > 0 && validations?.between_condition?.key === 'with_in') {
        today = today.subtract(validations.conditional_hours, 'hours').millisecond(0);
        valid = selectedDate.isAfter(today);
      }
      if (valid && onlyTime && validations?.conditional_hours > 0 && validations?.between_condition?.key === 'beyond') {
        today = today.subtract(validations.conditional_hours, 'hours');
        valid = selectedDate.isBefore(today);
      }
      if (validations?.conditional_days > 0) {
        let specifiedDays = Number(validations?.conditional_days);
        let conditionalDays = moment(today).subtract(specifiedDays, 'days').millisecond(0);
        if (validations?.between_condition?.key === 'with_in') {
          return selectedDate.diff(conditionalDays) > 0 && selectedDate.diff(today) <= 0;
        }
        if (validations?.between_condition?.key === 'after') {
          return selectedDate.diff(conditionalDays) <= 0;
        }
      }
    } if (validations?.condition?.key === 'greater_than' || (validations?.condition?.key === 'greater_than_custom_date' && customValidationDate)) {
        const dateToCheck = moment(rawDate);

        if (validations?.condition?.key === 'greater_than') {
            today = moment();
          }

        if (validations?.condition?.key === 'greater_than_custom_date') {
          today = moment(customValidationDate);
        }
    const isCalendarCell = dateToCheck.hour() === 0
          && dateToCheck.minute() === 0
          && dateToCheck.second() === 0
          && dateToCheck.millisecond() === 0;
    if (isCalendarCell) {
      // Calendar view → compare only date
      valid = dateToCheck.isSameOrAfter(today, 'day');
    } else {
      // Time selection → compare full datetime
      valid = dateToCheck.isSameOrAfter(today, 'minute');
    }
    // Conditional hours validation
    if (valid && onlyTime && validations?.conditional_hours > 0) {
      const hours = Number(validations?.conditional_hours);
      if (validations?.between_condition?.key === 'with_in') {
        const maxTime = moment(today).add(hours, 'hours');
        valid = dateToCheck.isBefore(maxTime, 'minute');
      }
      if (validations?.between_condition?.key === 'beyond') {
        const minTime = moment(today).add(hours, 'hours');
        valid = dateToCheck.isAfter(minTime, 'minute');
      }
    }
      // Conditional days validation
      if (validations?.conditional_days > 0) {
        const baseDate = moment(today).startOf('day');
        const dateToCheckDay = moment(rawDate).startOf('day');
        const specifiedDays = Number(validations?.conditional_days);
        const conditionalDays = moment(baseDate).add(specifiedDays, 'days');
        if (validations?.between_condition?.key === 'with_in') {
          return (dateToCheckDay.isSameOrAfter(baseDate) && dateToCheckDay.isBefore(conditionalDays));
        }
        if (validations?.between_condition?.key === 'after') {
          return dateToCheckDay.isSameOrAfter(conditionalDays);
        }
      }
    }
    return valid;
  }

  getErrorMessage = () => {
    const { settings, onlyTime } = this.props;
    const validations = settings?.validations || {};
    let message = {
      id: 'pulpofield.time.valid.error',
      message: 'Incorrect'
    };
    if (validations?.condition?.key === 'less_than') {
      message = {
        id: 'pulpofield.time.valid.less_than',
        message: 'Please select a time and date equal to or earlier than the current time and date.'
      };
      if (onlyTime) {
        message = {
          id: 'pulpofield.time.valid.less_than_time',
          message: 'Please select the current time or any time prior to it.'
        };
      }
      if (onlyTime && validations?.conditional_hours > 0 && validations?.between_condition?.key === 'with_in') {
        message = {
          id: 'pulpofield.time.valid.less_than_hours',
          message: `Please select a time within the current time and up to ${validations?.conditional_hours} hours prior to it.`
        };
      }
      if (onlyTime && validations?.conditional_hours > 0 && validations?.between_condition?.key === 'beyond') {
        message = {
          id: 'pulpofield.time.valid.less_than_hours',
          message: `Please select a time ${validations?.conditional_hours} hours prior to the current time.`
        };
      }
    } else if (validations?.condition?.key === 'greater_than') {
      message = {
        id: 'pulpofield.time.valid.greater_than',
        message: 'Please select a time and date equal to or later than the current time and date'
      };
      if (onlyTime) {
        message = {
          id: 'pulpofield.time.valid.greater_than_time',
          message: 'Please select the current time or time later than it.'
        };
      }
      if (onlyTime && validations?.conditional_hours > 0 && validations?.between_condition?.key === 'with_in') {
        message = {
          id: 'pulpofield.time.valid.greater_than_hours',
          message: `Please choose the time within the next ${validations?.conditional_hours} hours from the current time`
        };
      }
      if (onlyTime && validations?.conditional_hours > 0 && validations?.between_condition?.key === 'beyond') {
        message = {
          id: 'pulpofield.time.valid.greater_than_hours',
          message: `Please choose the time beyond the next ${validations?.conditional_hours} hours from the current time`
        };
      }
    }
    return message;
  }


  getStyle = () => {
    let obj = {};
    obj={
      position: 'relative',
      width: '100%'
    };
    return obj;
  }

  render() {
    const { fieldId, answer, onlyTime, noDefault, className, customField, disabled, fromGate,
      myforms, settings, showFieldErrors, dateEditable, sendWithSecond } = this.props;
    const { currentDate, renderAnswer } = this.state;
    const useSeconds = getFieldUsesSeconds({ sendWithSecond, settings }, sendWithSecond);
    const formatString = getDateTimeFormat(useSeconds);

    const displayValue = (() => {
      if (!answer) {
        return '';
      }
      if (onlyTime) {
        return renderInfoForType({ type: 'time' }, answer, null, null, null, null, null, useSeconds);
      }
      return renderInfoForType({ type: 'datetime' }, answer, null, null, null, null, null, useSeconds);
    })();

    const displayCurrentValue = (() => {
      if (!currentDate) {
        return '';
      }
      if (onlyTime) {
        return renderInfoForType({ type: 'time' }, currentDate, null, null, null, null, null, useSeconds);
      }
      return renderInfoForType({ type: 'datetime' }, currentDate, null, null, null, null, null, useSeconds);
    })();
    return (
      <div style={myforms ? {} : this.getStyle()}>
        {customField && (
          <img src={icon} alt=""
            style={{ color: 'gray', position: 'absolute', right: '2%', top: '20%', zIndex: '1000' }}
          />
        )}
        {dateEditable
          && (
            <Datetime
              {...(onlyTime ? { dateFormat: false } : {})}
              defaultValue={displayValue || (!noDefault && displayCurrentValue)}
              closeOnSelect
              onChange={e => this.handleAnswerChanged(e, fieldId)}
              id={`date-field-${fieldId}`}
              viewDate={moment().toDate()}
              isValidDate={settings?.validations && this.handleDisableFutureDates}
              dateFormat={onlyTime ? false : `${localStorage.getItem('dateFormat')}` || 'MM/DD/YYYY'}
              timeFormat={getTimeFormat(useSeconds)}
              className={`${customField ? styles.dateField : className}`}
              disabled={disabled}
              renderInput={props => (
                <input
                  {...props}
                  value={renderAnswer ? displayValue : props?.value}
                  className={styles.read_only_input}
                />
              )}
          />
          )
        }
        {!fromGate && !dateEditable
          && (
          <Datetime
            {...(onlyTime ? { dateFormat: false } : {})}
            defaultValue={displayValue || (!noDefault && displayCurrentValue)}
            closeOnSelect
            onChange={e => this.handleAnswerChanged(e, fieldId)}
            id={`date-field-${fieldId}`}
            viewDate={moment().toDate()}
            isValidDate={settings?.validations && this.handleDisableFutureDates}
            dateFormat={onlyTime ? false : `${localStorage.getItem('dateFormat') || 'MM/DD/YYYY'}`}
            timeFormat={getTimeFormat(useSeconds)}
            className={`${customField ? styles.dateField : className}`}
            disabled={disabled}
            renderInput={props => (
              <input
                {...props}
                value={renderAnswer ? displayValue : props?.value}
                className={styles.read_only_input}
              />
            )}
          />
          )
        }
        {answer
        && dateEditable
        && !moment(answer, [moment.ISO_8601, formatString], true).isValid()
        && (
          <small key={fieldId}>
            <FormattedMessage
              id="pulpofield.datetime.error"
              defaultMessage="Incorrect format. Please fix and try again."
            />
          </small>
        )}
        {answer && settings?.validations
          && this.handleDisableFutureDates(moment(answer)) === false
          && showFieldErrors && (
            <small key={fieldId} style={{ paddingLeft: '15px' }}>
              <FormattedMessage
                id={this.getErrorMessage()?.id}
                defaultMessage={this.getErrorMessage()?.message}
              />
            </small>
        )}
        {fromGate && !dateEditable
          && (
          <Datetime
            {...(onlyTime ? { dateFormat: false } : {})}
            defaultValue={displayValue || (!noDefault && displayCurrentValue)}
            closeOnSelect
            onChange={e => this.handleAnswerChanged(e, fieldId)}
            id={`date-field-${fieldId}`}
            viewDate={moment().toDate()}
            isValidDate={settings?.validations && this.handleDisableFutureDates}
            dateFormat={onlyTime ? false : `${localStorage.getItem('dateFormat') || 'MM/DD/YYYY'}`}
            timeFormat={getTimeFormat(useSeconds)}
            className={`${customField ? styles.dateField : className}`}
            disabled={disabled}
            renderInput={props => (
              <input
                {...props}
                value={renderAnswer ? displayValue : props?.value}
                className={styles.read_only_input}
              />
            )}
          />
          )
        }
      </div>
    );
  }
}


Date.defaultProps = {
  answer: undefined,
  onlyTime: false
};

Date.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  onlyTime: PropTypes.bool
};

export default Date;
